import { render, staticRenderFns } from "./MarketResearch.vue?vue&type=template&id=74fffa22&"
import script from "./MarketResearch.vue?vue&type=script&lang=js&"
export * from "./MarketResearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports